import { render } from "./ContentPayments.vue?vue&type=template&id=7abf2c2c&scoped=true"
import script from "./ContentPayments.vue?vue&type=script&lang=js"
export * from "./ContentPayments.vue?vue&type=script&lang=js"

import "./ContentPayments.vue?vue&type=style&index=0&id=7abf2c2c&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src895191040/src/tracker-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7abf2c2c"]])

export default __exports__